module.exports = __webpack_public_path__ + "img/Facebook_onLight.cb7ec4b0.svg";